<form class="d-inline" [formGroup]="keywordsearch_form">
  <div class="mb-1 p-3 wccard">
    <div class="d-flex">
      <div class="position-relative col-md pl-0">
        <input data-testid="auto-app-quick-search-input-1" type="text" class="wc-form-control no-shadow icn-find mr-2" id="searchkeyword" formControlName="keyword"
          placeholder="Keyword or boolean search using Job Title, Skill, Name, Company or Industry…"
          (click)="getPersonSearchListing($event)" (input)="getPersonSearchListing($event)" [matAutocomplete]="auto">
      </div>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectSearch($event.option.value)">
        <mat-option disabled
          *ngIf="keywordsearch_form?.value?.keyword && keywordsearch_form?.value?.keyword.length >= 3 && !isBooleanString"
          [value]="keywordsearch_form?.controls['keyword'].value">
          <div class="d-flex mt-1 align-items-center">
            <i class="f-12 mr-2 fa-solid fa-magnifying-glass text-9696"></i><span style="color: #484b59;">Search for
              {{keywordsearch_form?.value?.keyword}} in </span>
            <mat-chip-grid class="ml-2 pointer">
              <mat-chip-row class="my-2 rightsideclose text-truncate search-chip pointer" *ngFor="let s of searchChips"
                style="min-height:26px!important; cursor: pointer;" (click)="searchFromListing(s)">
                <span class="trim-chip text-truncate f-12 d-flex align-items-center">
                  <span class="mx-1 f-12" style="font-weight: normal;">{{s | titlecase}}</span>

                </span>
              </mat-chip-row>
            </mat-chip-grid>
          </div>

        </mat-option>
        <hr class="my-1 pl-2" style="border-top:1px solid #d9d9d9">
        <mat-option *ngFor="let option of personSearchListing" [value]="option">
          <span class="f-14"><i class="f-12 fa-solid mr-2 text-9696"
              [ngClass]="option?.type == 'jobtitle' ? 'fa-briefcase' : option?.type == 'skill' ? 'fa-paintbrush-pencil':'fa-solid fa-user'"></i>{{
            option.value}}<i class="fas fa-circle text-9696 mx-2" style="font-size:5px"
              *ngIf="option?.job_title || option?.job_company_name"></i><span *ngIf="option?.job_title"
              class="f-12 text-9696">{{option?.job_title}}<span *ngIf="option?.job_company_name"> &#64;
                {{option?.job_company_name}}</span></span></span> <span
            class="f-12 text-9696 mt-2 float-right">{{option.type == 'fullname' ? 'Person': option.type}}</span>
        </mat-option>

        <mat-option *ngIf="showQuickSearchLoader && !isBooleanString">
          <div class="d-flex align-items-center">
            <div class="d-flex spinner-border position-absolute text-black mr-2" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <span style="margin-left:30px;">Searching ...</span>
          </div>


        </mat-option>
      </mat-autocomplete>
      <div class="row">

        <div class="col" style="max-width: 0px;">
          <span class="ml-6 hoverToShowGuideline" style="margin-left: 2px !important;">
            <i class="fas fa-question-circle" style="margin-top: 8px;"></i>
            <div class="searchGuide f-14" style="margin-top: 100px;color: #484b59;font-family: Poppins;">

              <div class="row">
                <div class="col">
                  <h5 class="mb-3"> BOOLEAN SEARCH</h5>
                  <p>Use operators: "Quotes",
                    <span class="text-highlighted font-weight-600">AND</span>,
                    <span class="text-highlighted font-weight-600">OR</span>,
                    <span class="text-highlighted font-weight-600">NOT</span>, (Parenthesis) and Asterix*
                  </p>
                  <p>Examples -</p>
                  <p> "text": "data scientist" "data engineer"</p>
                  <p>
                    <span class="text-highlighted font-weight-600">AND</span>: "data scientist"
                    <span class="text-highlighted font-weight-600">AND</span>
                    "mumbai"
                  </p>
                  <p>
                    <span class="text-highlighted font-weight-600">OR</span>: "data scientist"
                    <span class="text-highlighted font-weight-600">OR</span>
                    "software engineer"
                  </p>
                  <p>
                    <span class="text-highlighted font-weight-600">NOT</span>: "Brand Manager"
                    <span class="text-highlighted font-weight-600">NOT</span>
                    "Assistant Brand Manager"
                  </p>
                  <p> Asterix*: admin* = administration, administrator, administer, administered, etc.</p>
                  <p> Words in the left will have more weightage in the search compared to the right-hand side. </p>
                  <p> Make sure to include important words in the beginning</p>
                  <p> Include location in the Boolean</p>
                  <p> Boolean search will show results of words matched in a candidate's summary</p>
                  <p> For detailed information on how to use boolean search click here </p>
                </div>
                <div class="col">
                  <h5 class="mb-3"> KEYWORD SEARCH</h5>
                  <p class="mb-3">Start typing and select from the dropdown and hit search</p>
                  <p class="mb-3">If the word is not found,continue typing,when done,finish with a comma(,) Can type as
                    a
                    keyword</p>
                  <p class="mb-3">Results from keyword search will not show keywords matched in candidates summary</p>
                  <p>Eg: Data Scientist, Machine Learning Engineer, India</p>
                </div>
              </div>
            </div>
          </span>
        </div>

        <div class="col text-right">
          <button data-testid="auto-app-quick-search-button-1" class="wc-btn bg-blue m-auto py-2" (click)="search()" style="padding: 8px 16px;">Search
            Talent</button>
        </div>
      </div>
    </div>
    <p class="text-danger f-12  mb-0 mt-1" *ngIf="quicksearcherror">{{quicksearcherror}}</p>
    <p *ngIf="keywordsearch_form['controls'].keyword.hasError('pattern')" class="text-danger f-12 pt-1">
      HTML tags are not allowed</p>
  </div>

</form>
<div class="row mt-4 mx-0">
  <div class="col-md-8 pl-0">
    <div class="d-flex justify-content-between pr-3">
      <p class="f-16 font-weight-600">My Talentpools</p>

      <span class="font-weight-500 text-webbtree-green pointer" *ngIf="showViewAll?.length>6"
        (click)="redirectToTalentpool()">View All</span>
    </div>
    <!-- <app-talentpool-history (viewAllUpdate)="checkTalentpool($event)"></app-talentpool-history> -->
  </div>
  <div class="col-md-4 px-0">
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-between wccard p-3" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0;">
          <div class="f-16 font-weight-600">Search History</div>
          <span class="font-weight-500 text-webbtree-green pointer" *ngIf="showHistoryViewAll?.length>5"
            (click)="viewAllHistory()">View All</span>
        </div>
        <div class="px-3 bg-white">
          <div class="" style="border-top: 1px solid rgba(0, 0, 0, 0.1); height: 1px;">&nbsp;</div>
        </div>
        <app-search-history [calledFrom]="'mainscreen'" [events]="historySubject.asObservable()"
          (viewHistoryUpdate)="checkHistory($event)"></app-search-history>
      </div>

      <div class="col-12">
        <div class="d-flex justify-content-between pt-3 wccard p-3" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0;">
          <p class="f-16 font-weight-600 mb-0">Save Search</p>
          <span class="font-weight-500 text-webbtree-green pointer" *ngIf="showSavedHistoryViewAll?.length>5"
            (click)="viewAllHistory(true)">View All</span>
        </div>
        <div class="px-3 bg-white">
          <div class="" style="border-top: 1px solid rgba(0, 0, 0, 0.1); height: 1px;">&nbsp;</div>
        </div>
        <app-search-history save=true [calledFrom]="'mainscreen'" [events]="savedHistorySubject.asObservable()"
          (viewSavedHistoryUpdate)="checkHistory($event, true)"></app-search-history>
      </div>
    </div>

  </div>
</div>
